// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"build_node_index_js":"3c11e2698e0ea054f9f980fc255b43f691d04755ae59f30500d7fc46c863ed2d","node_modules_react_index_js":"322dd505b94fc6c6f0343105da33504882dbd4ab7cf2f3e05c42087c11591e18"}[chunkId] + ".js";
};